import { motion } from 'framer-motion';

const RightSidebar = ({ children, ...rest }) => (
  <motion.div
    initial={false}
    animate='visible'
    exit='hidden'
    variants={{hidden: { x: '100%', opacity: 0, filter: 'blur(10px)' }, visible: { x: 0, opacity: 1, filter: 'blur(0px)' }}}
    transition={{ duration: 0.3, ease: 'linear' }}
    {...rest}
  >
    {children}
  </motion.div>
);

export default RightSidebar;
